import { lddGlobalSessionInfo, UserRights } from "../navigationTypes";
import { FIRMPROFILE, FIRMSESSION } from "./const";

export async function handleFirmUpdate(SessionInfo: lddGlobalSessionInfo): Promise<lddGlobalSessionInfo> {
    try {
        const res = await fetch(`getprofile.asp?pname=LawyerProfile&SessionID=${SessionInfo.sid}`);
        const data = await res.text();
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(data, "text/xml");
        const lawyer = xmlDoc.getElementsByTagName('lawyer')[0];
        
        if (lawyer) {
            FIRMPROFILE.forEach((attr, index) => {
                const value = lawyer.getAttribute(attr);
                if (value && value > "") {
                    SessionInfo.firm[FIRMSESSION[index]] = value;
                }
            });
        }
    } catch(error) {
        console.log('[SESSION_INFO]: Unable to update firm with profile attributes.')
    }
    return SessionInfo;
}

async function handleGenSessionInfo(
    resSession: any,
    appcodeRes: Response,
    responsePromises: Response[],
    URLsid: string
): Promise<lddGlobalSessionInfo> {
    const [resUser, resFirm] = await Promise.all(responsePromises.map(r => r.json()));
    const { UserID, StationID, isMSLogin, Username, isAdmin } = resSession.result;
    const UserInfo = resUser.result;
    let { FirstName, Initials, LastName, FullName, SubUserID, UserEmail, UserPhone, UserCellPhone, MSLoginEmail } = UserInfo;
    // For legacy reasons, email and phone are referred to as FirmEmail/FirmPhone if we redo database, can change the names
    UserEmail = UserInfo.FirmEmail;
    UserPhone = UserInfo.FirmPhone;
    if (!(Initials > "")) {
        if (FirstName > "") {
            Initials = FirstName.toUpperCase().substring(0, 1);
        }
        if (LastName > "") {
            Initials += LastName.toUpperCase().substring(0, 1);
        }
    }
    if (!(FullName > "")) {
        if (FirstName > "") {
            FullName = FirstName
        }
        if (LastName > "") {
            FullName += ` ${LastName}`
        }
    }
    const FirmInfo = resFirm.result.firm;
    let { FirmName, FirmPhone, FirmCity, FirmFax, FirmEmail, FirmStreet1, FirmProvince, FirmPostalCode, Lawyers } = FirmInfo;
    const resAppCode = appcodeRes instanceof Response ? await appcodeRes.json() : appcodeRes;
    const appCode = resAppCode.AppCode.toUpperCase();

    const SessionInfo: lddGlobalSessionInfo = {
        appCode: appCode,
        appCountry: resAppCode.Country,
        appProvince: "Ontario",
        appProvinceShort: "ON",
        sid: URLsid,
        user: {
            isAdmin: isAdmin,
            account: StationID,
            id: SubUserID,
            firstname: FirstName,
            lastname: LastName,
            fullname: FullName,
            initials: Initials,
            email: UserEmail,
            phone: UserPhone,
            cell: UserCellPhone,
            userRights: [],
        },
        firm: {
            account: Username,
            id: UserID,
            name: FirmName,
            phone: FirmPhone,
            city: FirmCity,
            fax: FirmFax,
            email: FirmEmail,
            address: FirmStreet1,
            province: FirmProvince,
            postalcode: FirmPostalCode,
            Lawyers: Lawyers,
            Staffs: [],
            IsCollege: FirmInfo.IsCollege,
            IsCollegeDefaultAdmin: FirmInfo.IsCollegeDefaultAdmin,
            PaymentReminderDate: FirmInfo.PaymentReminderDate ?? null
        },
        MSLoginEmail: (isMSLogin) ? MSLoginEmail : "",
        betaUser: {}
    };

    switch (appCode) {
        case "RPWAB":
            SessionInfo.appProvinceShort = "AB";
            SessionInfo.appProvince = "Alberta";
            break;
        case "RPWSK":
            SessionInfo.appProvinceShort = "SK";
            SessionInfo.appProvince = "Saskatchewan";
            break;
        case "RPWMB":
            SessionInfo.appProvinceShort = "MB";
            SessionInfo.appProvince = "Manitoba";
            break;
        case "RPWBC":
            SessionInfo.appProvinceShort = "BC";
            SessionInfo.appProvince = "British Columbia";
            break;
        case "RPWNS":
            SessionInfo.appProvinceShort = "NS";
            SessionInfo.appProvince = "Nova Scotia";
            break;
    }

    const UserRightProps = Object.getOwnPropertyNames(UserInfo).filter(prop => 
        prop.startsWith("loginRPW") || 
        prop.startsWith("createRPW") || 
        prop.startsWith("deleteRPW") || 
        prop.startsWith("modifyRPW") || 
        prop.startsWith("docsRPW") || 
        prop.startsWith("postRPW") ||
        prop.startsWith("adminRPW") ||
        prop.startsWith("importRPW") ||
        prop.startsWith("form4RPW")
    );
    if (UserRightProps.length > 0) {
        SessionInfo.user.userRights = UserRightProps.map(right => ({ name: right as UserRights, enabled: UserInfo[right] === "1" ? false : true }));
    }

    try {
        // Staff Info
        const staffPromise = await fetch(`/${process.env.REACT_APP_RWAPI_ENDPOINT}/api/${SessionInfo.appProvinceShort}/${UserID}/get/list?SessionID=${URLsid}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                searchType: "all_staff_member",
                page: 0
            })
        });
        if (staffPromise.status === 200) {
            const resStaff = await staffPromise.json();
            SessionInfo.firm.Staffs = resStaff.result;
        }
    } catch (error) {
        console.warn("[SESSION_INFO]: Unable to fetch staff info.", error);
    }

    try {
        // Beta User List
        const betaUserRes = await fetch("js/BetaUser.json", { method: "GET", cache: "default" });

        if (betaUserRes.status === 200) {
            const betaUser = await betaUserRes.json();
            SessionInfo.betaUser = betaUser;
        }
    } catch (error) {
        console.warn("[SESSION_INFO]: Unable to fetch beta user list.", error);
    }
    return { ...SessionInfo };
}
export default handleGenSessionInfo;